import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IssuesRatioCheckKpiData } from 'src/app/models/issues-ratio-check-kpi-data.model';
import { ProductionKeyPerformanceIndicatorEvaluationWithData } from 'src/app/models/production-key-performance-indicator-evaluation.model';
import { SecondsToHourStringPipe } from 'src/app/pipes/seconds-to-hour-string.pipe';

@Component({
  selector: 'app-issues-ratio-check-details',
  imports: [CommonModule, MatTooltipModule, SecondsToHourStringPipe],
  templateUrl: './issues-ratio-check-details.component.html',
  styleUrl: './issues-ratio-check-details.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssuesRatioCheckDetailsComponent {
  kpiData = input.required<ProductionKeyPerformanceIndicatorEvaluationWithData>();

  detailsData = computed((): IssuesRatioCheckKpiData | null => {
    const rawData = this.kpiData().data?.[0]?.data;
    return IssuesRatioCheckDetailsComponent.isIssuesRatioCheckKpiData(rawData) ? rawData : null;
  });

  issuesBarWidth = computed((): number => {
    const data = this.detailsData();
    if (data === null || data.total_working_time_in_seconds === 0) {
      return 0;
    }
    return (data.issues_working_time_in_seconds / data.total_working_time_in_seconds) * 100;
  });

  nonIssuesBarWidth = computed((): number => Math.max(0, 100 - this.issuesBarWidth()));

  private static isIssuesRatioCheckKpiData(value: unknown): value is IssuesRatioCheckKpiData {
    if (typeof value !== 'object' || value === null) {
      return false;
    }

    const candidate = value as Partial<IssuesRatioCheckKpiData>;

    return (
      typeof candidate.total_working_time_in_seconds === 'number' &&
      typeof candidate.issues_working_time_in_seconds === 'number' &&
      typeof candidate.non_issues_working_time_in_seconds === 'number' &&
      typeof candidate.total_completed_tasks_count === 'number' &&
      typeof candidate.issues_completed_tasks_count === 'number' &&
      typeof candidate.non_issues_completed_tasks_count === 'number'
    );
  }
}
